export default () => {
  return {
    initial: {
      query: '',
      access_type: [],
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'services::accesses.filters.dropdown.items.query.label',
        placeholder: 'services::accesses.filters.input.placeholder',
        order: 1,
        type: 'input',
      },
      // access_type: {
      //   subbutton: {
      //     isVisible: (value = [], breakpoints) =>
      //       value.length > 0 || !!breakpoints.fb,
      //   },
      //   icon: (
      //     <Icon
      //       name={'avatar1'}
      //       size={'s'}
      //       bgColor={'Accent-Confirm-Secondary'}
      //       color={'Label-Onsurface'}
      //     />
      //   ),
      //   label: 'services::accesses.roles.label',
      //   position: 'dropdown',
      //   type: 'checkbox group',
      //   optionLabelPrefix: 'services::accesses.roles.options.',
      //   options: [
      //     'manager',
      //     'reports',
      //     'full_access',
      //     'readonly',
      //     'fin_readonly',
      //     'ads_readonly',
      //     'vkads_full_readonly_access',
      //   ],
      // },
    },
  }
}
